import React, { useState } from 'react';
import './Footer.css';

function Footer() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    setMessage('');

    try {
      // Get form data
      const form = e.target;
      const formData = new FormData(form);
      
      // Submit to Netlify Forms
      const response = await fetch("/", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(formData).toString()
      });
      
      if (response.ok) {
        setIsSuccess(true);
        setMessage('Thank you for subscribing!');
        setEmail('');
      } else {
        setMessage('Something went wrong. Please try again.');
      }
    } catch (error) {
      console.error('Form submission error:', error);
      setMessage('Network error. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-subscription">
          <h3>Stay Updated</h3>
          <p>
            Subscribe to receive notifications only when a new book or album is coming out or has been released.
            <br />
            <span className="privacy-note">Your email will never be sold or used for spam.</span>
          </p>
          
          {!isSuccess ? (
            <form 
              name="email-subscription"
              method="POST"
              data-netlify="true"
              onSubmit={handleSubmit} 
              className="subscription-form"
              netlify-honeypot="bot-field"
            >
              <input type="hidden" name="form-name" value="email-subscription" />
              <p hidden>
                <label>Don’t fill this out: <input name="bot-field" /></label>
              </p>
              <div className="form-group email-group"> {/* Added class for specific styling */}
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Your email address"
                  required
                  className="email-input"
                />
              </div>
              <div className="form-group interest-group"> {/* New group for interest */}
                <label htmlFor="user_interest" className="sr-only">Interest:</label> {/* Screen-reader only label */}
                <select id="user_interest" name="user_interest" required className="interest-select">
                  <option value="" disabled selected>Interest: Music, Books, or Both?</option>
                  <option value="Music">Music</option>
                  <option value="Books">Books</option>
                  <option value="Both">Both</option>
                </select>
              </div>
              <div className="form-group button-group"> {/* Group for the button */}
                <button
                  type="submit"
                  className="btn btn-primary subscribe-btn"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Subscribing...' : 'Subscribe'}
                </button>
              </div>
              {message && <p className="message">{message}</p>}
            </form>
          ) : (
            <div className="success-message">
              <p>{message}</p>
              <button 
                onClick={() => {
                  setIsSuccess(false);
                  setMessage('');
                }}
                className="btn btn-secondary"
              >
                Subscribe Another Email
              </button>
            </div>
          )}
        </div>
        
        <div className="footer-info">
          <p>&copy; {new Date().getFullYear()} D Byron. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;